<template>
  <div class="grip-team-detail-container">
    <h1 :class="$style.title">GRiP PROJECT TEAM</h1>
    <div class="columns is-multiline width-100 margin-none">
      <div class="column is-half margin-bottom6">
        <b-field
          label="Project Leader"
          :message="errorMessage.projectLead"
          :type="errorMessage.projectLead ? 'is-danger' : undefined"
        >
          <b-input
            v-model="dirtyGripDetail.projectLead"
            type="text"
            @input="validateData()"
            :disabled="isDataCollector"
          >
          </b-input>
        </b-field>
      </div>
      <div class="column is-half margin-bottom6">
        <b-field label="Date to Implement Action">
          <b-datepicker
            placeholder="Select a date"
            icon="calendar-today"
            icon-pack="mdi"
            v-model="dirtyGripDetail.actionDate"
            class="calender-icon"
            :date-formatter="formatDateRange"
            :disabled="isDataCollector"
          >
          </b-datepicker>
        </b-field>
      </div>
      <div class="column margin-bottom6">
        <b-field label="Stakeholders">
          <b-input
            v-model="dirtyGripDetail.stakeholder"
            type="textarea"
            :disabled="isDataCollector"
          ></b-input>
        </b-field>
      </div>
    </div>
    <div v-if="!isDataCollector" class="columns level width-100 margin-none">
      <div class="level-left" />
      <div class="level-right padding-horizontal-12">
        <button
          class="button is-primary is-rounded"
          @click="handleSave()"
          :disabled="disableSubmitButton"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { monthsList } from '../../../store/types/general.types';
import {
  Grip,
  GripDTO,
  UpdateGripPayload,
} from '../../../store/types/grip.types';

@Component({
  components: {},
})
export default class GripTeamDetailCard extends Vue {
  @Prop() public gripDetails!: Grip;
  @Prop() public projectId!: number;
  @Prop() public isDataCollector!: boolean;

  public errorMessage: {
    projectLead: string | null;
  } = { projectLead: null };

  public dirtyGripDetail: GripDTO = {
    projectLead: '',
    stakeholder: '',
    actionDate: new Date(),
  };

  get disableSubmitButton(): boolean {
    return !this.projectLeadValue.trim();
  }

  get projectLeadValue(): string {
    return this.dirtyGripDetail.projectLead ?? '';
  }

  public formatDateRange(date: Date): string {
    return (
      date.getDate() +
      ' ' +
      monthsList[date.getMonth()] +
      ' ' +
      date.getFullYear()
    );
  }

  public validateData(): void {
    this.errorMessage = {
      projectLead: !this.projectLeadValue.trim()
        ? 'This Field is Required'
        : null,
    };
  }

  @Watch('gripDetails', { immediate: true, deep: true })
  public syncDirtyGripDetailFromProp(): void {
    if (this.gripDetails?.id != null) {
      this.dirtyGripDetail.projectLead = this.gripDetails.projectLead ?? '';
      this.dirtyGripDetail.stakeholder = this.gripDetails.stakeholder ?? '';
      this.dirtyGripDetail.actionDate = this.gripDetails.actionDate
        ? new Date(this.gripDetails.actionDate)
        : new Date();
    }
  }

  public handleSave(): void {
    if (this.gripDetails?.id != null) {
      const updateGrip: UpdateGripPayload = {
        id: this.gripDetails.id,
        projectId: this.projectId,
        ...this.dirtyGripDetail,
      };
      this.$emit('updateGrip', updateGrip);
    } else {
      this.$emit('createGrip', {
        ...this.dirtyGripDetail,
        projectId: this.projectId,
      });
    }
  }
  public mounted(): void {
    this.syncDirtyGripDetailFromProp();
  }
}
</script>
<style lang="scss" module>
.title {
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #444f51;
  margin: 0 0.75rem 0.75rem 0.75rem;
}
</style>
